import axiosInstance from '../axios-instance.ts';
import { ApiResponse, ApiParams } from '@models/api.model.ts';
import {
  DepartmentReqModel,
  DepartmentsModel
} from '@models/departments-and-units/departments.model.ts';

export const getDepartments = async (
  params?: ApiParams
): Promise<ApiResponse<DepartmentsModel>> => {
  const response = await axiosInstance.get('/pms/departments/getter', { params });
  return response.data;
};

export const createDepartment = async (
  body: DepartmentReqModel
): Promise<DepartmentsModel> => {
  return await axiosInstance.post(`/pms/departments`, body);
};

export const editDepartment = async (
  body: DepartmentReqModel,
  id: number
): Promise<DepartmentsModel> => {
  return await axiosInstance.put(`/pms/departments/${id}`, body);
};

export const changeStatus = async (
  id: number,
  isActive: boolean
): Promise<any> => {
  const response = await axiosInstance.put(`/pms/departments/changeStatus/${id}`, {
    status: isActive
  });
  return response.data;
};
